// app/lib/tracking/facebook.ts

/**
 * Facebook Pixel event'i (browser side).
 * Aynı event'i CAPI'den de göndereceğiz, dedup için event_id kullanılır.
 */
export const fbqEvent = (
  eventName: string,
  params: Record<string, unknown> = {},
  eventId?: string,
): void => {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;

  if (eventId) {
    window.fbq("track", eventName, params, { eventID: eventId });
  } else {
    window.fbq("track", eventName, params);
  }
};
